// extracted by mini-css-extract-plugin
export default {"page":"BankingRecon_page__y7ROi","summaryRow":"BankingRecon_summaryRow__qmXzZ","tableSection":"BankingRecon_tableSection__keht6"};